import React from 'react';

const WelcomeMessage = () => {
    return (
        <div className="WelcomeMessage">
            <div>
                Youth Camps For Christ has enjoyed over 50 years of ministry! The
                Lord has been faithfully at work through the ministries of{' '}
                <a target="_blank" href="http://www.campwillowsprings.org">
                    Camp Willow Springs
                </a>{' '}
                and{' '}
                <a target="_blank" href="http://www.campwillowrun.org">
                    Camp Willow Run
                </a>{' '}
                and we are amazed at all He has done. Through summer camp
                sessions and retreats countless people have trusted Christ,
                grown in their faith, and had fun!
            </div>

            <div>
                We would love to hear from you about the way the Lord has
                impacted you through YCFC. Share your story via{' '}
                <a
                    target="_blank"
                    href="https://twitter.com/search?f=tweets&vertical=default&q=%23myCWSstory%20OR%20%23myCWRstory&src=typd">
                    Twitter
                </a>{' '}
                or{' '}
                <a
                    target="_blank"
                    href="https://www.instagram.com/explore/tags/myCWRstory/">
                    Instagram
                </a>{' '}
                with the hashtag #myCWSstory or #myCWRstory. Or email us at{' '}
                <a href="mailto:mystory@youthcampsforchrist.org">
                    mystory@youthcampsforchrist.org
                </a>
            </div>

            <div>
                Thank you for sharing your story and thank you for being a part
                of Youth Camps For Christ!
            </div>
        </div>
    );
};

export default WelcomeMessage;



// WEBPACK FOOTER //
// ./src/components/WelcomeMessage.js